module.exports = __webpack_public_path__ + "img/thumb_21.0315254c.jpg";